import './ListResults.scss';
import Component from './ListResults.js';
export default Component;
